import { ReactComponent as OutlineInvoice } from "assets/svg/outline-invoice.svg";
// import {
//   isInvoicingSessionCancelledByPro,
//   isNonInvoicedInvoicingSessionCancelledByPatient,
//   isNonInvoicedInvoicingSessionCancelledByPro,
// } from "components/Dashboard/DoctorDashboard/utils/isInvoicingSessionCancelled";
import messages from "messages";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import InvoicingTag from "../../../../../calendar-view/components/scrollable-calendar-view/components/appointment-timeslot/components/invoicing-tag/InvoicingTag";
import styles from "../../SessionSidesheet.module.scss";

interface InvoiceRowProps {
  appointment: AppointmentWithSeriesInfo & {
    invoice?: InvoiceData;
  };
  nextStatus: string | null;
  isWaitingForInvoice: boolean;
  trackClick: (name: string) => void;
  requestInvoice: () => Promise<void>;
}

const InvoiceRow = ({
  appointment,
  nextStatus,
  isWaitingForInvoice,
  trackClick,
  requestInvoice,
}: InvoiceRowProps) => {
  /* for invoicing session, only session cancelled by pro does not have invoice */

  // if (
  //   isInvoicingSessionCancelledByPro(appointment, nextStatus) ||
  //   isNonInvoicedInvoicingSessionCancelledByPro(appointment)
  // ) {
  //   return (
  //     <>
  //       <hr className={styles["divider"]} />
  //       <div className={styles["text-with-icon"]}>
  //         <OutlineInvoice />

  //         <div className="rg-14 gray01">No Invoice for cancelled session</div>
  //       </div>
  //     </>
  //   );
  // }

  if (appointment.pricing?.list_price === 0) {
    return (
      <>
        <hr className={styles["divider"]} />
        <div className={styles["text-with-icon"]}>
          <OutlineInvoice />

          <div className="rg-14 gray01">No Invoice for free session</div>
        </div>
      </>
    );
  }

  if (!appointment.statusFlags.usingInvoicing) {
    return null;
  }

  if (!appointment.invoice) {
    // if (isNonInvoicedInvoicingSessionCancelledByPatient(appointment)) {
    //   return null;
    // }

    return (
      <>
        <hr className={styles["divider"]} />
        <div className={styles["text-with-icon"]}>
          <OutlineInvoice />
          <Button
            disabled={isWaitingForInvoice}
            variant={"link"}
            className={"p-0"}
            onClick={() => {
              trackClick("create-invoice-button");
              requestInvoice();
            }}
          >
            {isWaitingForInvoice
              ? messages.creatingInvoice
              : messages.createInvoice}
          </Button>
        </div>
      </>
    );
  }

  return (
    <>
      <hr className={styles["divider"]} />
      <div className={"d-flex py-1"}>
        {/* if invoice is fully paid, go to view invoice. if invoice is closed,  */}
        <div className={styles["text-with-icon"]}>
          <OutlineInvoice />
          <Link
            to={`/pro-dashboard/invoicing/view/appointment/${appointment.appointment_id}`}
            onClick={() => {
              trackClick("view-invoice-link");
            }}
            target="_blank"
            rel="noopener noreferrer"
          >
            {`Invoice # ${appointment.invoice.invoice_no}`}
          </Link>
        </div>
        <InvoicingTag invoice={appointment.invoice} />
      </div>
    </>
  );
};

export default InvoiceRow;
